function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3EDFF"
    },
    d: "M441.183,254.356c14.583-15.636,28.273-36.722,20.822-56.498 c-7.471-19.828-31.973-27.424-53.464-31.215c-21.491-3.791-45.869-7.982-57.772-25.675 c-12.014-17.857-6.276-42.908-18.082-60.894c-12.537-19.1-39.238-22.885-62.569-24.794c-35.578-2.91-72.215-5.718-106.303,4.542 c-34.089,10.261-65.431,36.902-69.31,71.184c-3.943,34.846,20.397,70.184,9.692,103.678 c-11.111,34.765-56.335,53.941-60.84,90.063c-2.358,18.909,7.49,37.021,17.026,53.692c12.2,21.33,24.4,44.01,36.599,65.34 h302.91c-4.354-5.934-0.044-14.474,6.034-18.767c6.078-4.293,13.69-6.291,19.532-10.88c15.47-12.151,11.98-36.013,3.258-53.332 c-8.722-17.319-21.548-34.252-20.491-53.484C409.381,286.302,426.6,269.992,441.183,254.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3EDFF"
    },
    d: "M68.192,269.004c32.677-31.467,30.185-48.212,23.477-90.135 c-3.273-20.458-29.288-0.409-38.569,30.604C43.36,242.014,50.804,285.747,68.192,269.004z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Artwork_52_8_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8C1E8"
    },
    d: "M174.676,427.999c-4.322,7.685-63.93,24.128-64.374,1.483 c-0.373-19.071,42.968-13.393,58.868-6.699c-4.741-4.636-9.284-9.424-13.638-14.184c-4.169-4.56-8.176-9.251-12.025-14.06 c-9.354,5.963-66.777,7.401-62.181-13.974c3.677-17.104,38.372-5.513,54.852,4.364c-5.794-7.89-11.187-16.064-16.195-24.472 c-6.899,5.949-68.081,3.887-61.816-17.767c5.235-18.095,44.019-0.493,57.696,10.647c-5.121-9.123-9.813-18.493-14.066-28.062 c-8.72,4.598-67.621-5.444-58.686-25.854c7.391-16.884,42.159,4.304,54.995,17.243c-2.233-5.404-4.325-10.865-6.295-16.369 c-9.187-3.749-39.643-55.01-18.331-61.432c20.135-6.069,25.637,47.137,21.41,59.229c2.21,6.226,4.604,12.382,7.156,18.466 c0.749-16.998,14.849-59.969,31.878-50.479c19.177,10.69-19.141,54.88-29.037,57.097c4.19,9.429,8.823,18.647,13.863,27.635 c-1.012-17.736,7.382-60.059,25.1-53.033c20.137,7.987-10.962,55.613-20.941,60.23c6.081,10.211,12.73,20.082,19.963,29.545 c-3.445-14.917,1.438-63.922,20.794-57.771c21.332,6.781-8.953,59.605-17.585,61.925c3.949,4.982,8.054,9.853,12.335,14.588 c3.837,4.242,7.849,8.502,12.033,12.644c-6.165-16.864-10.523-59.208,8.357-57.764c21.585,1.653,6.05,56.297-2.115,63.72 c7.785,7.151,16.121,13.729,25.013,18.971c2.046,1.206-0.16,4.168-2.191,2.971C190.661,441.615,182.41,435.088,174.676,427.999z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Artwork_54_7_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DAD4F8"
    },
    d: "M265.736,446.289c2.105-13.763,4.989-27.403,8.637-40.84 c3.641-13.408,8.057-26.604,13.183-39.517c5.136-12.941,10.992-25.598,17.53-37.891c6.524-12.268,13.727-24.17,21.589-35.627 c7.839-11.427,16.317-22.414,25.395-32.883c1.151-1.327,2.313-2.645,3.482-3.956c1.528-1.714-1.216-3.982-2.737-2.276 c-9.355,10.488-18.108,21.507-26.204,32.994c-8.074,11.455-15.508,23.367-22.262,35.648 c-6.741,12.258-12.797,24.891-18.133,37.822c-5.373,13.018-10.001,26.337-13.89,39.872 c-3.863,13.444-6.968,27.104-9.276,40.899c-0.29,1.733-0.566,3.467-0.832,5.204 C261.872,447.999,265.388,448.561,265.736,446.289L265.736,446.289z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DAD4F8"
    },
    d: "M322.337,299.297c-2.613-27.203,4.588-67.502,5.234-94.286 c0.712-29.555,4.842-61.331,29.828-78.465c6.517-4.469,14.83-7.802,24.049-6.568c12.952,1.733,24.262,12.323,28.653,23.23 c4.391,10.908,3.234,22.013,1.14,32.42C401.017,226.456,369.146,270.791,322.337,299.297"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DAD4F8"
    },
    d: "M283.06,373.034c-17.937-18.805-35.972-53.09-51.151-73.474 c-16.749-22.493-32.163-48.627-22.925-75.934c2.409-7.122,6.869-14.439,14.7-18.869c11.002-6.225,25.921-4.88,35.691,0.719 c9.77,5.599,15.377,14.567,19.855,23.556C301.098,272.939,302.471,324.563,283.06,373.034"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DAD4F8"
    },
    d: "M269.375,412.603c14.12-25.911,44.59-60.272,61.269-84.614 c18.405-26.86,41.095-54.517,72.971-61.156c8.315-1.732,17.495-1.77,24.709,2.714c10.134,6.298,13.52,20.125,10.744,31.73 c-2.776,11.605-10.459,21.374-18.529,30.163C381.121,374.363,326.93,403.46,269.375,412.603"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Artwork_50_4_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8C1E8"
    },
    d: "M258.852,447.664c17.026-4.677,33.544-13.514,48.71-23.163c0.664,0.449,1.63,1.066,2.862,1.754 c2.509,1.432,6.119,3.213,10.462,4.837c4.339,1.618,9.426,3.107,14.878,4.164c5.469,1.069,11.306,1.694,17.154,1.915 c5.86,0.172,11.724-0.066,17.243-0.784c2.772-0.347,5.43-0.805,7.974-1.343c2.527-0.533,4.921-1.201,7.152-1.847 c2.218-0.671,4.244-1.387,6.075-2.102c1.805-0.723,3.377-1.42,4.674-2.059c2.613-1.27,4.114-2.264,4.114-2.264 s-1.435-1.098-3.946-2.522c-1.264-0.73-2.801-1.529-4.557-2.365c-1.754-0.829-3.749-1.662-5.914-2.492 c-2.175-0.786-4.522-1.616-7.024-2.299c-2.504-0.702-5.13-1.337-7.866-1.862c-5.458-1.077-11.298-1.687-17.151-1.887 c-5.853-0.152-11.73,0.085-17.243,0.809c-5.522,0.687-10.681,1.852-15.126,3.191c-2.178,0.658-4.177,1.366-5.966,2.071 c1.133-0.771,2.266-1.53,3.392-2.301c10.864-7.405,21.217-15.454,31.148-23.966c0.517,0.313,1.118,0.665,1.815,1.062 c2.517,1.44,6.131,3.217,10.472,4.832c4.341,1.624,9.416,3.113,14.881,4.171c5.446,1.074,11.302,1.696,17.152,1.915 c5.857,0.18,11.724-0.051,17.233-0.782c2.764-0.345,5.433-0.802,7.975-1.346c2.529-0.525,4.933-1.195,7.155-1.847 c2.227-0.67,4.247-1.387,6.068-2.091c1.797-0.726,3.383-1.426,4.686-2.065c2.607-1.267,4.108-2.261,4.108-2.261 s-1.438-1.102-3.938-2.524c-1.278-0.727-2.813-1.533-4.556-2.364c-1.761-0.829-3.748-1.667-5.927-2.494 c-2.165-0.792-4.514-1.607-7.015-2.305c-2.5-0.702-5.138-1.325-7.868-1.854c-5.458-1.068-11.302-1.685-17.149-1.881 c-5.858-0.16-11.729,0.074-17.24,0.793c-5.519,0.709-10.692,1.857-15.131,3.201c-2.325,0.703-4.443,1.462-6.326,2.193 c9.508-8.538,18.583-17.534,27.228-26.949c0.624,0.154,1.332,0.33,2.153,0.507c2.848,0.592,6.827,1.199,11.451,1.43 c4.629,0.236,9.923,0.12,15.447-0.535c5.523-0.627,11.282-1.796,16.927-3.368c5.642-1.596,11.16-3.597,16.199-5.958 c2.525-1.164,4.931-2.401,7.183-3.692c2.26-1.268,4.345-2.627,6.264-3.921c1.904-1.327,3.638-2.612,5.146-3.841 c1.502-1.236,2.815-2.375,3.843-3.383c2.103-1.986,3.231-3.401,3.231-3.401s-1.695-0.609-4.526-1.215 c-1.423-0.302-3.117-0.598-5.057-0.861c-1.925-0.263-4.065-0.461-6.387-0.597c-2.311-0.084-4.807-0.16-7.391-0.062 c-2.591,0.089-5.294,0.285-8.064,0.6c-5.521,0.638-11.278,1.817-16.911,3.401c-5.636,1.613-11.145,3.619-16.192,5.983 c-4.953,2.285-9.425,4.897-13.2,7.457c6.971-8.168,13.653-16.594,20.051-25.244c2.286-1.433,5.052-3.362,8.002-5.811 c3.563-2.982,7.363-6.657,10.981-10.881c3.652-4.214,7.075-8.974,10.156-13.958c3.061-4.991,5.762-10.206,7.871-15.366 c1.061-2.567,1.982-5.11,2.774-7.578c0.792-2.458,1.396-4.885,1.942-7.137c0.511-2.262,0.896-4.388,1.173-6.312 c0.272-1.93,0.454-3.638,0.53-5.093c0.206-2.886,0.063-4.689,0.063-4.689s-1.654,0.703-4.144,2.18 c-1.259,0.74-2.706,1.669-4.299,2.791c-1.591,1.111-3.319,2.424-5.098,3.906c-1.769,1.498-3.645,3.126-5.483,4.96 c-1.84,1.822-3.693,3.798-5.5,5.905c-3.64,4.21-7.061,8.987-10.145,13.973c-3.023,5.004-5.72,10.23-7.833,15.377 c-2.126,5.15-3.675,10.204-4.71,14.723c-1.035,4.518-1.537,8.507-1.73,11.402c-0.066,0.982-0.089,1.821-0.1,2.528 c-10.362,13.797-21.497,27.036-33.406,39.5c0.986-2.532,2.081-5.798,3.013-9.583c1.098-4.507,1.973-9.728,2.387-15.273 c0.422-5.551,0.345-11.421-0.12-17.254c-0.515-5.838-1.434-11.634-2.806-17.025c-0.679-2.715-1.435-5.311-2.274-7.764 c-0.826-2.453-1.765-4.756-2.669-6.889c-0.946-2.123-1.888-4.056-2.808-5.773c-0.932-1.712-1.807-3.198-2.603-4.422 c-1.552-2.434-2.716-3.799-2.716-3.799s-0.928,1.544-2.045,4.209c-0.581,1.342-1.189,2.956-1.816,4.8 c-0.607,1.849-1.212,3.917-1.776,6.163c-0.517,2.256-1.066,4.687-1.458,7.254c-0.396,2.553-0.717,5.246-0.923,8.017 c-0.423,5.557-0.347,11.432,0.146,17.264c0.53,5.841,1.469,11.633,2.83,17.027c1.339,5.393,3.101,10.392,4.957,14.646 c1.851,4.246,3.817,7.757,5.383,10.187c0.548,0.862,1.051,1.599,1.476,2.168c-12.11,12.32-24.977,23.846-38.68,34.323 c0.223-0.499,0.472-1.054,0.74-1.683c1.121-2.672,2.451-6.463,3.555-10.966c1.107-4.507,1.977-9.719,2.395-15.265 c0.418-5.548,0.356-11.421-0.123-17.268c-0.512-5.836-1.436-11.634-2.805-17.036c-0.668-2.684-1.432-5.294-2.274-7.741 c-0.825-2.449-1.769-4.755-2.67-6.891c-0.94-2.128-1.88-4.07-2.808-5.774c-0.924-1.706-1.796-3.197-2.595-4.426 c-1.558-2.421-2.729-3.799-2.729-3.799s-0.921,1.544-2.044,4.215c-0.569,1.335-1.179,2.951-1.806,4.798 c-0.611,1.848-1.222,3.917-1.774,6.173c-0.54,2.248-1.084,4.685-1.455,7.237c-0.411,2.562-0.73,5.256-0.93,8.033 c-0.413,5.543-0.343,11.412,0.153,17.253c0.518,5.836,1.457,11.639,2.816,17.036c1.35,5.395,3.105,10.389,4.959,14.633 c1.858,4.249,3.82,7.749,5.385,10.194c0.771,1.209,1.449,2.164,1.926,2.811c-5.268,3.976-10.652,7.806-16.172,11.447 c-6.764,4.474-13.823,8.947-21.109,13.078c0.301-0.622,0.65-1.377,1.016-2.275c1.135-2.676,2.472-6.46,3.553-10.963 c1.123-4.502,1.999-9.729,2.398-15.263c0.43-5.564,0.368-11.428-0.124-17.272c-0.503-5.836-1.421-11.624-2.782-17.019 c-0.671-2.71-1.447-5.313-2.29-7.765c-0.818-2.448-1.767-4.759-2.667-6.889c-0.933-2.114-1.883-4.063-2.808-5.773 c-0.931-1.708-1.811-3.196-2.592-4.41c-1.564-2.44-2.729-3.808-2.729-3.808s-0.919,1.545-2.055,4.213 c-0.558,1.336-1.178,2.957-1.795,4.796c-0.621,1.849-1.214,3.916-1.788,6.171c-0.523,2.246-1.073,4.696-1.441,7.244 c-0.409,2.562-0.734,5.249-0.934,8.024c-0.416,5.556-0.339,11.42,0.146,17.261c0.538,5.834,1.453,11.628,2.825,17.037 c1.344,5.395,3.106,10.376,4.952,14.628c1.863,4.255,3.826,7.748,5.401,10.196c0.779,1.24,1.47,2.205,1.96,2.857 c-10.697,5.948-21.89,11.086-33.412,14.249C255.241,444.538,256.391,448.341,258.852,447.664z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "phone-call_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA5455"
    },
    d: "M184.379,96.799c4.742,0,8.586,3.844,8.586,8.586c0,1.581,1.281,2.862,2.862,2.862 s2.862-1.281,2.862-2.862c0-7.904-6.407-14.311-14.311-14.311c-1.581,0-2.862,1.281-2.862,2.862 C181.517,95.518,182.799,96.799,184.379,96.799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA5455"
    },
    d: "M184.379,85.351c11.065,0,20.035,8.97,20.035,20.035c0,1.581,1.281,2.862,2.862,2.862 c1.581,0,2.862-1.281,2.862-2.862c0-14.226-11.533-25.759-25.759-25.759c-1.581,0-2.862,1.281-2.862,2.862 C181.517,84.069,182.799,85.351,184.379,85.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454975"
    },
    d: "M209.423,119.439c-0.32-0.934-1.099-1.637-2.061-1.86l-17.173-3.921 c-0.947-0.215-1.939,0.065-2.633,0.744c-0.401,0.372-0.429,0.401-2.29,3.95c-6.173-2.844-11.119-7.811-13.939-13.996 c3.635-1.832,3.663-1.832,4.036-2.261c0.679-0.695,0.959-1.686,0.744-2.633l-3.921-16.972c-0.223-0.962-0.926-1.741-1.86-2.061 c-0.668-0.239-1.359-0.411-2.061-0.515c-0.723-0.168-1.462-0.264-2.204-0.286c-7.271,0-13.166,5.895-13.166,13.166 c0.032,24.33,19.747,44.045,44.077,44.077c7.271,0,13.166-5.895,13.166-13.166l0,0c0.001-0.729-0.056-1.456-0.172-2.175 C209.847,120.817,209.665,120.118,209.423,119.439z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "talk_chat_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454975"
    },
    d: "M349.667,104.83h-35.166c-7.288,0-13.251-5.963-13.251-13.251l0,0 c0-7.288,5.963-13.251,13.251-13.251h35.166c7.288,0,13.251,5.963,13.251,13.251l0,0 C362.918,98.867,356.956,104.83,349.667,104.83z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454975"
    },
    d: "M352.974,108.902c0,1.617-1.311,2.928-2.928,2.928c-1.617,0-2.928-1.311-2.928-2.928 c0-1.617,1.311-2.928,2.928-2.928C351.663,105.974,352.974,107.285,352.974,108.902z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M324.396,91.22c0,2.122-1.72,3.842-3.842,3.842s-3.842-1.72-3.842-3.842s1.72-3.842,3.842-3.842 S324.396,89.098,324.396,91.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M335.927,91.22c0,2.122-1.72,3.842-3.842,3.842s-3.842-1.72-3.842-3.842s1.72-3.842,3.842-3.842 S335.927,89.098,335.927,91.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M347.457,91.22c0,2.122-1.72,3.842-3.842,3.842s-3.842-1.72-3.842-3.842s1.72-3.842,3.842-3.842 S347.457,89.098,347.457,91.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA5455"
    },
    d: "M298.407,135.618h35.166c7.288,0,13.251-5.963,13.251-13.251l0,0 c0-7.288-5.963-13.251-13.251-13.251h-35.166c-7.288,0-13.251,5.963-13.251,13.251l0,0 C285.156,129.655,291.119,135.618,298.407,135.618z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA5455"
    },
    d: "M295.1,139.69c0,1.617,1.311,2.928,2.928,2.928c1.617,0,2.928-1.311,2.928-2.928 c0-1.617-1.311-2.928-2.928-2.928C296.411,136.762,295.1,138.073,295.1,139.69z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M308.302,122.13c0,2.122-1.72,3.842-3.842,3.842s-3.842-1.72-3.842-3.842 c0-2.122,1.72-3.842,3.842-3.842S308.302,120.008,308.302,122.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M319.833,122.13c0,2.122-1.72,3.842-3.842,3.842c-2.122,0-3.842-1.72-3.842-3.842 c0-2.122,1.72-3.842,3.842-3.842C318.112,118.288,319.833,120.008,319.833,122.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M331.363,122.13c0,2.122-1.72,3.842-3.842,3.842c-2.122,0-3.842-1.72-3.842-3.842 c0-2.122,1.72-3.842,3.842-3.842C329.643,118.288,331.363,120.008,331.363,122.13z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A6AFE2"
    },
    d: "M246.629,214.702c-1.218,3.142-3.261,5.664-5.664,7.294c-3.066,2.109-6.729,2.783-10.045,1.5 c-5.903-2.283-8.436-9.936-5.664-17.078c2.761-7.142,9.795-11.078,15.698-8.795c0.033,0.011,0.065,0.022,0.098,0.044 C246.89,200.004,249.38,207.603,246.629,214.702z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Character_man_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB8B8"
    },
    d: "M101.909,204.04c6.178,9.416,24.167,36.78,34.258,51.611 c-7.651,14.318-23.671,22.238-23.671,22.238s-8.283-22.163-12.645-34.159c-4.362-11.995-7.741-21.335-7.61-27.469 c0.018-0.848,0.713-1.131,1.185-1.229l-0.659-1.193c-0.803-1.454-0.228-3.284,1.262-4.017c0.947-0.466,2.02-0.344,2.855,0.196 l-1.222-1.977c-1.01-1.634-0.605-3.77,0.933-4.921C98.308,201.839,100.735,202.252,101.909,204.04z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F18B8B"
    },
    d: "M107.653,242.086c0.189-7.446,6.858-13.331,9.412-14.971l0.887,1.383 c-3.266,2.096-8.506,7.652-8.657,13.63L107.653,242.086z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.031,
    y: 208.903,
    transform: "matrix(0.8639 -0.5037 0.5037 0.8639 -96.2354 80.8396)",
    style: {
      fill: "#F18B8B"
    },
    width: 0.822,
    height: 19.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.548,
    y: 214.438,
    transform: "matrix(0.9015 -0.4327 0.4327 0.9015 -87.0643 63.9349)",
    style: {
      fill: "#F18B8B"
    },
    width: 0.821,
    height: 17.689
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB8B8"
    },
    d: "M270.451,228.42l0.038,0.627l0.366,19.221l0.935,48.812l-58.436-15.712l28.147-18.519 l-0.283-7.35l-0.954-25.53c-0.34-8.29,6.082-15.308,14.367-15.727C262.944,213.848,269.959,220.217,270.451,228.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F18B8B"
    },
    d: "M270.451,228.42l0.038,0.627l0.366,19.221c-3.022,1.623-6.164,3.018-9.312,4.282 c-5.069,2.034-9.571,3.458-15.05,3.472c-1.757,0-3.593-0.021-5.275-0.523l-0.954-25.53 c-0.34-8.29,6.082-15.308,14.367-15.727C262.944,213.848,269.959,220.217,270.451,228.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454975"
    },
    d: "M282.897,218.419c-4.326,10.484-7.595,14.56-11.149,13.436 c-10.247,17.551-24.348,24.164-36.927,20.75c-10.206-2.744-9.682-17.614-6.819-31.077c0.679-3.108,1.465-6.17,2.267-8.971 c1.326-4.563,3.519-10.829,6.584-17.855c-8.083-25.051,16.179-30.543,32.191-12.286c0.854-0.628,1.769-1.102,2.725-1.343 c4.228-1.197,8.978,1.952,12.536,13.615C291.629,202.716,287.25,207.933,282.897,218.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B3E63"
    },
    d: "M277.186,194.013c-1.328-2.463-3.791-5.514-8.141-11.598c0.854-0.628,1.769-1.102,2.725-1.343 C273.867,185.01,276.857,191.149,277.186,194.013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB8B8"
    },
    d: "M279.548,222.028c-4.913,9.89-12.52,5.444-13.204,1.474c-3.978,5.797-6.563,7.289-8.334,7.473 c-1.772,0.185-6.704-2.927-8.816-3.613c-2.14-0.711-12.808,2.394-21.165-5.809l-0.028-0.025 c0.679-3.108,1.465-6.17,2.267-8.971c1.326-4.563,3.519-10.829,6.584-17.855c4.531-5.751,18.365-16.832,34.547,11.692 c-1.295,5.505-2.222,9.729-3.389,12.551C275.907,209.4,284.462,212.164,279.548,222.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F18B8B"
    },
    d: "M269.228,220.682c0.363-0.955,0.9-1.835,1.597-2.58c0.671-0.771,1.497-1.419,2.433-1.901 c0.931-0.477,1.988-0.809,3.106-0.752c0.551,0.015,1.13,0.158,1.624,0.479c0.49,0.313,0.849,0.884,0.775,1.411 c-0.301-0.436-0.696-0.623-1.1-0.673c-0.395-0.071-0.814-0.024-1.227,0.063c-0.826,0.185-1.635,0.525-2.426,0.932 c-0.795,0.402-1.567,0.886-2.347,1.405C270.872,219.573,270.119,220.156,269.228,220.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F18B8B"
    },
    d: "M270.225,219.58c0.37-0.454,0.926-0.763,1.508-0.905c0.585-0.153,1.21-0.156,1.816-0.009 c0.598,0.158,1.194,0.494,1.562,1.032c0.383,0.528,0.456,1.2,0.31,1.757c-0.344-1.142-1.1-1.762-2.076-1.994 c-0.479-0.131-0.995-0.166-1.516-0.155C271.308,219.333,270.775,219.392,270.225,219.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F18B8B"
    },
    d: "M241.639,209.469c-4.903,6.417-10.723,9.131-11.456,10.845s1.805,5.069,8.136,6.22 C242.065,224.16,239.035,220.273,241.639,209.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454975"
    },
    d: "M253.548,212.091c0.09,1.505-0.829,2.784-2.054,2.857c-1.225,0.073-2.29-1.087-2.381-2.591 c-0.09-1.505,0.829-2.784,2.054-2.857C252.392,209.426,253.458,210.586,253.548,212.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454975"
    },
    d: "M237.686,210.603c-0.284,1.48-1.49,2.493-2.695,2.262c-1.205-0.231-1.952-1.618-1.668-3.098 c0.283-1.48,1.49-2.493,2.695-2.262C237.223,207.735,237.97,209.122,237.686,210.603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454975"
    },
    d: "M254.072,198.516c4.417,0.126,6.509,5.35,7.178,8.188c0.329,1.398-0.597,1.777-1.345,0.471 c-0.92-1.605-3.408-4.518-6.221-5.633C251.694,200.753,252.356,198.467,254.072,198.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454975"
    },
    d: "M241.438,196.354c-3.726-1.528-6.849,1.121-8.426,3.335c-0.833,1.17-0.213,2.332,1.048,1.51 c1.55-1.011,3.333-2.261,6.346-1.974C242.536,199.428,243.026,197.005,241.438,196.354z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M201.222,416.205c13.401,4.706,27.215,7.551,50.174,5.387 c13.407-43.309,15.564-147.339,16.003-153.138c-10.515,4.042-23.493,6.394-28.982-6.395 C212.121,291.71,201.068,337.013,201.222,416.205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA5455"
    },
    d: "M271.028,257.373c-14.207,8.202-23.157,33.107-25.517,71.157 c-2.36,38.049-5.283,72.823-4.317,84.171c0.966,11.347,4.346,29.678,24.689,31.31c20.342,1.631,50.344,2.683,50.344,2.683 s-23.919-146.834-24.731-155.625C290.684,282.278,287.749,268.494,271.028,257.373z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB8B8"
    },
    d: "M440.177,421.202c-9.361-6.261-36.565-24.491-51.306-34.713 c-14.385,7.524-22.446,23.474-22.446,23.474s22.089,8.479,34.046,12.946c11.956,4.467,21.266,7.93,27.4,7.852 c0.848-0.011,1.137-0.703,1.239-1.174l1.188,0.669c1.447,0.816,3.282,0.257,4.028-1.227 c0.474-0.943,0.362-2.017-0.171-2.857l1.967,1.24c1.625,1.025,3.764,0.638,4.929-0.89 C442.346,424.822,441.955,422.391,440.177,421.202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB8B8"
    },
    d: "M396.503,392.572l33.484,8.627c1.935,0.499,3.124,2.445,2.683,4.394l0,0 c-0.46,2.038-2.516,3.289-4.538,2.762l-20.008-5.213C408.125,403.143,392.279,400.422,396.503,392.572z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F18B8B"
    },
    d: "M406.19,414.438c-1.271,0.409-2.612,0.66-4.007,0.682l-0.026-1.642 c5.98-0.099,11.579-5.287,13.705-8.535l1.374,0.898C415.886,407.907,411.706,412.664,406.19,414.438z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.34,
    y: 411.982,
    transform: "matrix(0.5113 -0.8594 0.8594 0.5113 -154.2125 571.8867)",
    style: {
      fill: "#F18B8B"
    },
    width: 0.821,
    height: 19.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.481,
    y: 417.137,
    transform: "matrix(0.4406 -0.8977 0.8977 0.4406 -146.9609 616.1234)",
    style: {
      fill: "#F18B8B"
    },
    width: 0.821,
    height: 17.689
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA5455"
    },
    d: "M271.028,257.373c18.372,13.006,24.065,22.359,29.594,33.718 c5.529,11.359,26.296,48.606,32.473,56.505c6.176,7.898,55.777,38.893,55.777,38.893l-26.49,29.245 c0,0-50.777-22.369-60.533-32.904C292.091,372.295,270.525,333.112,271.028,257.373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA5455"
    },
    d: "M241.368,259.737l0.187,4.865c-11.092,12.201-19.687,33.69-24.43,61.266 c-5.389,31.233-7.461,64.443-7.673,91.931c-0.124,18.91-17.599,18.673-26.244,12.218c1.837-24.885,9.035-84.96,12.942-103.31 C199.893,309.126,207.473,258.047,241.368,259.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA5455"
    },
    d: "M241.387,260.05l0.057,1.386c-17.546,6.872-26.907,40.074-26.907,40.074 s-10.929,34.305-20.957,42.234c-19.464,15.389-33.97,11.308-44.93-0.332c-5.788-6.147-42.317-64.445-42.317-64.445 l29.879-23.699l33.84,45.449c0,0,28.71-20.493,39.532-28.457C219.35,265.043,227.668,259.929,241.387,260.05z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 283.958,
    y: 323.472,
    transform: "matrix(0.9317 -0.3631 0.3631 0.9317 -107.2262 127.2215)",
    style: {
      fill: "#BB4344"
    },
    width: 1.643,
    height: 50.693
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.923,
    y: 317.532,
    transform: "matrix(0.3012 -0.9535 0.9535 0.3012 -164.3726 412.3982)",
    style: {
      fill: "#BB4344"
    },
    width: 26.554,
    height: 1.642
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E4169"
    },
    d: "M104.74,222.945l-30.676-30.676v26.275c0,5.083,4.12,9.203,9.203,9.203h42.947 c5.083,0,9.203-4.12,9.203-9.203v-26.275L104.74,222.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454975"
    },
    d: "M135.416,192.268v-4.401c0-5.083-4.12-9.203-9.203-9.203H83.266 c-5.083,0-9.203,4.12-9.203,9.203v4.401l30.676,30.676L135.416,192.268z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EA5455"
    },
    cx: 129.542,
    cy: 184.622,
    r: 11.304
  })), /*#__PURE__*/React.createElement("rect", {
    x: 81.077,
    y: 207.362,
    style: {
      fill: "#A6AFE2"
    },
    width: 20.145,
    height: 4.498
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB8B8"
    },
    d: "M130.151,247.965l-8.331-33.559c-0.481-1.94-2.417-3.145-4.37-2.722l0,0 c-2.041,0.442-3.311,2.487-2.802,4.513l5.036,20.053C119.684,236.25,122.264,252.12,130.151,247.965z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F18B8B"
    },
    d: "M242.219,230.122c-0.011,0.054-0.008,0.107-0.019,0.161c-1.222,9.701-12.779,10.688-13.634-1.156 c-0.058-0.613-0.078-1.268-0.059-1.952C231.7,227.294,239.377,229.248,242.219,230.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3EDFF"
    },
    d: "M242.219,230.122c-0.011,0.054-0.008,0.107-0.019,0.161c-1.308,0.334-2.73,0.54-4.24,0.617 c-3.792,0.192-7.215-0.518-9.394-1.773c-0.058-0.613-0.078-1.268-0.059-1.952C231.7,227.294,239.377,229.248,242.219,230.122z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A6AFE2"
    },
    d: "M284.817,223.628c-1.218,3.142-3.261,5.664-5.664,7.295c-3.066,2.109-6.729,2.783-10.045,1.5 c-5.903-2.283-8.436-9.936-5.664-17.079c2.761-7.142,9.795-11.077,15.698-8.795c0.033,0.011,0.065,0.022,0.098,0.044 C285.078,208.931,287.567,216.529,284.817,223.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A6AFE2"
    },
    d: "M275.503,206.723c4.503-6.332-0.603-18.574-6.457-24.308c0,0-2.116-2.309-2.828-2.874 c1.318,0.021,1.799,0.251,3.138,1.276c1.339,1.025,19.142,11.789,12.329,28.295C281.684,209.112,275.858,208.157,275.503,206.723z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBC3ED"
    },
    d: "M284.817,223.628c-1.218,3.142-3.261,5.664-5.664,7.295c-8.251,1.859-14.73-6.414-9.077-16.165 c2.479-4.272,5.773-6.892,9.164-8.164C285.078,208.931,287.567,216.529,284.817,223.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A6AFE2"
    },
    d: "M268.076,226.502c-4.992,4.992-14.791,5.527-22.539,5.653c-0.747,0.012-1.36,0.592-1.409,1.338l0,0 c-0.057,0.858,0.654,1.574,1.513,1.526c11.778-0.654,19.099-1.398,24.098-6.757L268.076,226.502z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EA5455"
    },
    cx: 245.579,
    cy: 233.531,
    r: 3.032
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DAD4F8"
    },
    cx: 150.23,
    cy: 132.165,
    r: 11.186
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DAD4F8"
    },
    d: "M267.898,96.977c0,2.535-2.055,4.589-4.589,4.589c-2.535,0-4.589-2.055-4.589-4.589 c0-2.534,2.055-4.589,4.589-4.589C265.844,92.388,267.898,94.443,267.898,96.977z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DAD4F8"
    },
    cx: 216.873,
    cy: 161.665,
    r: 3.278
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DAD4F8"
    },
    d: "M311.683,265.199c0,1.991-1.614,3.606-3.606,3.606c-1.991,0-3.606-1.614-3.606-3.606 c0-1.991,1.614-3.606,3.606-3.606C310.069,261.594,311.683,263.208,311.683,265.199z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454975"
    },
    d: "M329.899,332.592v69.434c0,6.86-5.555,12.426-12.426,12.426H194.26 c-6.86,0-12.415-5.566-12.415-12.426v-69.434c0-6.86,5.555-12.426,12.415-12.426h123.213 C324.344,320.166,329.899,325.732,329.899,332.592z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#393C61"
    },
    points: "288.339,414.451 243.713,414.451 242.126,362.237 269.608,362.237  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A6AFE2"
    },
    d: "M302.537,436.463h-23.296l-9.628-74.221H242.13l-9.628,74.221h-23.296 c-1.926,0-3.487,1.561-3.487,3.487v3.428h100.303v-3.428C306.023,438.024,304.462,436.463,302.537,436.463z M265.937,399.44 c0,5.559-4.506,10.065-10.065,10.065c-5.559,0-10.065-4.506-10.065-10.065v-4.201c0-5.559,4.506-10.065,10.065-10.065 c5.559,0,10.065,4.507,10.065,10.065V399.44z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F3EDFF",
      strokeWidth: 2.1742,
      strokeMiterlimit: 10
    },
    d: "M255.747,397.93 c-23.208,0-15.114,28.688-15.114,44.765"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454975"
    },
    d: "M370.641,177.364c-5.278,0-10.268,0.657-14.704,1.825c-2.271,0.598-3.859,2.639-3.859,4.987 v34.213v4.396c0,3.283,3.025,5.701,6.236,5.017c3.813-0.813,7.973-1.26,12.327-1.26c6.871,0,13.269,1.113,18.577,3.019v-11.173 v-38.006C383.91,178.477,377.512,177.364,370.641,177.364z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E4169"
    },
    d: "M407.794,177.364c-6.871,0-13.269,1.113-18.577,3.019v38.006v11.173 c5.308-1.906,11.706-3.019,18.577-3.019c4.354,0,8.513,0.447,12.327,1.26c3.211,0.684,6.236-1.734,6.236-5.017v-4.396v-34.213 c0-2.348-1.588-4.389-3.859-4.987C418.063,178.021,413.072,177.364,407.794,177.364z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454975"
    },
    d: "M425.336,448.11H72.566c-1.328,0-2.415-1.087-2.415-2.415l0,0c0-1.328,1.087-2.415,2.415-2.415 h352.771c1.328,0,2.415,1.087,2.415,2.415l0,0C427.751,447.023,426.665,448.11,425.336,448.11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/Contact.ed5590f009a35001df7ad61c4e87c85c.svg";
export { ForwardRef as ReactComponent };